//
//
//
//

import customer from '@/customer'
import HomeDefault from '@/pages/homeDefault'
import HomeYizhuanjia from '@/pages/homeYizhuanjia'

export default {
  name: 'home',
  components: {
    HomeDefault,
    HomeYizhuanjia
  },
  computed: {
    homeComponent(){
      return customer.home === 'yizhuanjia' ? 'HomeYizhuanjia' : 'HomeDefault'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home.vue